let config = {
	defaultLayout: 'vertical',
	errorMessages: 'first',
	errorMessagesGlue: '<br />',
};

export default config
